import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { IChildProject } from 'src/app/models/projects/project.model';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { DashboardHistoryService } from 'src/app/services/dashboard-history.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ProjectService } from 'src/app/services/project.service';
import { ViewComponent } from 'src/app/shared/pages/view/view.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-recent-project-cards',
    templateUrl: './recent-project-cards.component.html',
    styleUrls: ['./recent-project-cards.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class RecentProjectCardsComponent extends ViewComponent {

    get projects(): IChildProject[] {
        return this.s_dashboardHistory.dashboardRecents;
    };

    constructor(
        protected s_route: ActivatedRoute,
        protected s_router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected s_dashboardHistory: DashboardHistoryService,
        protected s_projects: ProjectService,
        protected translate: TranslateService
    ) {
        super(s_route, s_router, s_alert, s_loader, s_auth);
    }

    async refreshProjectsCards(event?: Event) {
        event?.stopPropagation();
        await this.s_dashboardHistory.refreshProjectsCards();
    }
}